const stripe_pricing_prod = [
  {
    priceId: "price_1Lehhd2VUebpFvYdpQ5DFB06",
    productId: "prod_MNScLoGtpeJD41",
    name: "Personal",
    amount: 4900,
    currency: "usd",
    interval: "month",
  },
  {
    priceId: "price_1Lehhd2VUebpFvYdNl9cYFfM",
    productId: "prod_MNScLoGtpeJD41",
    name: "Personal",
    amount: 49000,
    currency: "usd",
    interval: "year",
  },
  {
    priceId: "price_1LehhY2VUebpFvYdreCzPC6f",
    productId: "prod_MNScuOiVbWOsIz",
    name: "Team",
    amount: 34900,
    currency: "usd",
    interval: "month",
  },
  {
    priceId: "price_1LehhY2VUebpFvYdsMJK8zdh",
    productId: "prod_MNScuOiVbWOsIz",
    name: "Team",
    amount: 349000,
    currency: "usd",
    interval: "year",
  },
  {
    priceID: "price_1LehhS2VUebpFvYdexY1s6pM",
    productId: "prod_MNScvIkUtvjEMQ",
    name: "Agency",
    amount: 64900,
    currency: "usd",
    interval: "month",
  },
  {
    priceId: "price_1LehhS2VUebpFvYd4FYSisi0",
    productId: "prod_MNScvIkUtvjEMQ",
    name: "Agency",
    amount: 649000,
    currency: "usd",
    interval: "year",
  },
  {
    priceId: "price_1LehhJ2VUebpFvYdGL9UDTP4",
    productId: "prod_MNScjGrgAQO9yC",
    name: "Partner",
    amount: 129900,
    currency: "usd",
    interval: "month",
  },
  {
    priceId: "price_1LehhJ2VUebpFvYdyV5svwx7",
    productId: "prod_MNScjGrgAQO9yC",
    name: "Partner",
    amount: 1299000,
    currency: "usd",
    interval: "year",
  },
];
const stripe_pricing_dev = [
  {
    priceId: "price_1IKS0b2VUebpFvYddIkglIWj",
    productId: "prod_IwKfbBevU6eSS1",
    name: "Personal",
    amount: 4900,
    currency: "usd",
    interval: "month",
  },
  {
    priceId: "price_1IKS0b2VUebpFvYdbEC7JThp",
    productId: "prod_IwKfbBevU6eSS1",
    name: "Personal",
    amount: 49000,
    currency: "usd",
    interval: "year",
  },
  {
    priceId: "price_1IKS172VUebpFvYdPQWXhkQ4",
    productId: "prod_IwKgc91MLk0z45",
    name: "Team",
    amount: 34900,
    currency: "usd",
    interval: "month",
  },
  {
    priceId: "price_1IKS172VUebpFvYds4g3PcC2",
    productId: "prod_IwKgc91MLk0z45",
    name: "Team",
    amount: 349000,
    currency: "usd",
    interval: "year",
  },
  {
    priceID: "price_1IKS1Z2VUebpFvYdqVglhLG5",
    productId: "prod_IwKgm0JzfxNpWa",
    name: "Agency",
    amount: 64900,
    currency: "usd",
    interval: "month",
  },
  {
    priceId: "price_1IKS772VUebpFvYd5mmG2NZp",
    productId: "prod_IwKgm0JzfxNpWa",
    name: "Agency",
    amount: 649000,
    currency: "usd",
    interval: "year",
  },
  {
    priceId: "price_1IKS2J2VUebpFvYdBwlbtPhQ",
    productId: "prod_IwKh3uorK9u4Tt",
    name: "Partner",
    amount: 129900,
    currency: "usd",
    interval: "month",
  },
  {
    priceId: "price_1IKS2J2VUebpFvYdWYLarIzh",
    productId: "prod_IwKh3uorK9u4Tt",
    name: "Partner",
    amount: 1299000,
    currency: "usd",
    interval: "year",
  },
];

const stripe_pricing =
  process.env.VUE_APP_NODE_ENV == "production"
    ? stripe_pricing_prod
    : stripe_pricing_dev;
export { stripe_pricing };
